import { INoticePageIdTypes } from '../../modules/notification/types/noticePageIdTypes';
import { EUserType, userTypesSubscribers } from '../PageAuth/constants/authConstants';
import { ISubscriberIdMeta } from './types';

export interface ISubscriberIdMetaResponse extends INoticePageIdTypes, Omit<ISubscriberIdMeta, 'account' | 'userType'> {
    account: {
        id: number;
        number: string;
    };
    authority: number;
    currCountryName?: string;
    eventTimeChangeCountry?: string;
}

export const subscriberIdGeneralMapping = (
    { account, authority, ...response }: ISubscriberIdMetaResponse,
    userType: EUserType,
): ISubscriberIdMeta => {
    return {
        ...response,
        account: {
            ...account,
            // Лицевой счёт абонента не является ссылкой для пользователя с абонентским УД
            isLink: !userTypesSubscribers.includes(userType),
        },
        userType: authority,
    };
};
